(() => {
  "use strict";

  const baseUrl = String(
    document.querySelector('meta[name="peguu-api-base-url"]')?.content || ""
  ).replace(/\/+$/, "");

  const paths = Object.freeze({
    customers: "/api/customers",
    billingProfile: "/api/customers/me/billing-profile",
    customerOrders: "/api/customers/me/orders",
    shopifyCheckout: "/api/customers/me/shopify-checkout",
    materials: "/api/materials",
    materialsSummary: "/api/materials/public-products-summary",
    samplePack: "/api/materials/sample-pack",
    simulatorQuote: "/api/simulator/quote",
    corporateInquiries: "/api/corporate-inquiries",
  });

  const resolve = (pathOrUrl) => {
    const value = String(pathOrUrl || "").trim();

    if (!value) {
      return "";
    }

    if (/^[a-z][a-z\d+.-]*:\/\//i.test(value) || value.startsWith("//")) {
      return value;
    }

    return `${baseUrl}${value.startsWith("/") ? value : `/${value}`}`;
  };

  const endpoint = (name) => resolve(paths[name]);

  window.PeguuApi = Object.freeze({
    baseUrl,
    paths,
    resolve,
    endpoint,
  });
})();
